<template>
	<b-form-checkbox-group
		class="checkBoxGroup"
		:id="field.id"
		v-model="proxyValue"
		:options="field.options"
		:value-field="field.valueField"
		:text-field="field.textField"
		:disabled="field.disabled"
		@change="changed"
	></b-form-checkbox-group>
</template>

<script>
export default {
	props: {
		value: {
			type: Array
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		field: {
			type: Object
		}
	},
	data() {
		return {
			active: true
		};
	},
	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
			}
		}
	},
	methods: {
		changed(event) {
			this.$emit("checkChange", event);
		}
	},
	beforeMount() {
		this.active = typeof this.isActive == "function" ? this.isActive(null) : this.isActive;
	}
};
</script>

<style>
.checkBoxGroup {
	display: flex;
	flex-direction: column;
}
</style>
